import { cn } from '@lib/utils/cn';
import { ButtonHTMLAttributes, PropsWithChildren } from 'react';

interface ControlProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
}

export const Control = ({
  active = false,
  className,
  children,
  ...props
}: PropsWithChildren<ControlProps>) => (
  <button
    {...props}
    className={cn(
      'rounded-[12px] px-7 py-3 hover:cursor-pointer',
      active
        ? 'bg-surface-base-inverse-primary text-text-base-primary'
        : 'bg-surface-base-secondary text-text-base-secondary',
      className,
    )}
  >
    {children}
  </button>
);
